// Services
import apiClient from '@/services/AccountClient'

export default {
  fetchWalletIntegrator (walletId) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/integrators/${walletId}`
    )
  },
  addWalletIntegrator (walletId, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/integrators/${walletId}`,
      data
    )
  },
  deleteWalletIntegrator (walletId) {
    return apiClient.sendRequest(
      'DELETE',
      `api/admin/v1/integrators/${walletId}`
    )
  }
}
